import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IBoxService {
  // public apiBaseUrl = environment.baseUrliBox;
  apiBaseUrl: string;
  public headers: HttpHeaders;

  constructor(public http: HttpClient) {
    const config = environment;
    this.apiBaseUrl = config.apiICourrierBaseUrl;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  // Download the file associated with the version of a document
  downLoadFile(id: number, fileID?: number): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Mails/${id}/Files/${fileID}/Download`, {
      responseType: 'blob' as 'json',
    });
  }
  downLoadFileAttachement(id: number, fileID: number, fileName: string): Observable<Blob> {
    fileName = encodeURIComponent(fileName);
    return this.http.get<Blob>(`${this.apiBaseUrl}/Mails/${id}/Files/${fileID}/Download?attachmentFilename=${fileName}`, {
      responseType: 'blob' as 'json',
    });
  }
  downLoadScanFile(id: number, fileID?: number): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Scans/${id}/Files/${fileID}/Download`, {
      responseType: 'blob' as 'json',
    });
  }
}
